import { notification } from "antd"
import { useQuery, useQueryClient } from "react-query"
import { getResolvedTaxRate } from "./resolvedTaxRateApi"

export const useResolvedTaxRateQuery = (jobId: number, enabled: boolean) => {
  return useQuery(['resolved-tax-rate', jobId], {
    queryFn: () => getResolvedTaxRate(jobId),
    enabled,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    onError() {
      notification.error({ message: 'There was a problem determining the location-based tax rate.' })
    }
  })
}

export const useResolvedTaxRateInvalidator = () => {
  const queryClient = useQueryClient()

  return {
    invalidateForJob: (jobId: number) => {
      queryClient.invalidateQueries(['resolved-tax-rate', jobId])
    }
  }
}
